import ServiceGraphQL from 'src/service/gql-service';
import { createBill } from 'src/graphql';

const serviceGraphQL = new ServiceGraphQL();

/** Action creators */
export const CreateBill = (data) => {
  const params = {
    query: createBill.QUERY,
    variables: {
      record: data
    }
  };
  return serviceGraphQL
    .post(params)
    .then((res) => {
      return res;
    })
    .catch((err) => {
      throw err;
    });
};
